import { createAction } from 'redux-actions';

export const getAlertRules = createAction('GET_ALERT_RULES');
export const getAlertRulesSuccess = createAction('GET_ALERT_RULES_SUCCESS');
export const getAlertRulesFailure = createAction('GET_ALERT_RULES_FAILURE');

export const updateAlertRules = createAction('UPDATE_ALERT_RULES', (payload) => payload, (payload, meta) => meta);
export const updateAlertRulesSuccess = createAction('UPDATE_ALERT_RULES_SUCCESS');
export const updateAlertRulesFailure = createAction('UPDATE_ALERT_RULES_FAILURE');

